import { useState } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-[#1A0B2E] shadow-md sticky top-0 z-50">
      {/* <header className="bg-white shadow-md sticky top-0 z-50"> */}
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <h1 className="text-[#FFFFFF] font-jakarta text-font-20 font-semibold">
          Arisrada Dhanabalan
        </h1>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-6">
          <Link
            to="/"
            className="text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            Home
          </Link>
          <Link
            to="/about"
            className="text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            About
          </Link>
          <Link
            to="/projects"
            className="text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            Projects
          </Link>
          <Link
            to="/contact"
            className="text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            Contact
          </Link>
        </nav>

        {/* Mobile Toggle Button */}
        <button
          className="md:hidden text-gray-700 focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden px-4 pb-4 space-y-2 text-gray-700 font-medium">
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            className="block text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            Home
          </Link>
          <Link
            to="/about"
            onClick={() => setMenuOpen(false)}
            className="block text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            About
          </Link>
          <Link
            to="/projects"
            onClick={() => setMenuOpen(false)}
            className="block text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            Projects
          </Link>
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="block text-[#FFFFFF] font-jakarta text-font-16 font-medium hover:font-semibold"
          >
            Contact
          </Link>
        </div>
      )}
    </header>
  );
}
